export class ChipConfiguration {
    //******************************************************************************************************************
    //  Sizes used to generate table grid
    //******************************************************************************************************************

    public static colors: { [id: string]: Array<number> } = {
        1: [13],
        2: [1, 13],
        3: [0, 1, 13],
        4: [0, 1, 2, 13],
        5: [0, 1, 2, 3, 13],
        6: [0, 1, 2, 3, 4, 13],
        7: [0, 1, 2, 3, 4, 5, 13],
        8: [0, 1, 2, 3, 4, 5, 6, 13],
        9: [0, 1, 2, 3, 4, 5, 6, 7, 13],
        10: [0, 1, 2, 3, 4, 5, 6, 7, 8, 13],
        11: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 13],
        12: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 13],
        13: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13],
        14: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    };
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ChipConfiguration.ts
 **/